import { Member } from "./Member";
import { DAO } from "./DAO";
import { useAppContext } from "../../libs/app-core/AppContext";
import { useEffect, useState } from "react";
import { OnApiError } from "../ErrorManager";
import dayjs from "dayjs";
import { API, ApiResult } from "./API";
import { API_ROUTE_auth_member_login } from "../Routes";
import { WS_Public, WS, WS_Sys } from "./WS";
import { new_ErrorAlert } from "../export_spwk/ExportManager";
import { SpwkUtilV3 } from "./SpwkUtilV3";
import { HisDto } from "../export_spwk/HisDtoManager/HisDto";

export class MemberDAO {
  static async Select(project_guid: string): Promise<Member[]> {
    let cond = " WHERE (1=1) " + " AND " + Cnd.指定場次(project_guid);

    let data_list = await DAO.Select(Member, cond);
    return data_list;
  }

  static async WS_FetchByGuid(guid: string): Promise<Member> {
    let api_rslt: ApiResult = await WS.CallWS("member/fetch_by_guid", {
      guid: guid,
    });

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassObject(Member, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }

  static async Public_FetchCompleteBySid(
    sid: string | null
  ): Promise<string | null> {
    let api_rslt: ApiResult = await WS_Public.CallPublicGet("member/:sid", {
      sid: sid,
    });
    if (api_rslt.code === API.CODE_OK) {
      if (api_rslt.data.length === 1) {
        let Member_list = API.ToClassList(Member, api_rslt.data);
        let member = Member_list[0];
        return member.spwk_done_at;
        // return member;
      } else if (api_rslt.data.length === 0) {
        throw new_ErrorAlert(`1789465+不應該沒資料 !!!`);
      } else {
        throw new_ErrorAlert("74693156" + "未知的錯誤");
      }
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }

  static async Insert(data: Member): Promise<Member> {
    let refetch_data = await DAO.Insert(Member, data);
    return refetch_data;
  }

  static async Update(data: Member): Promise<Member> {
    let refetch_data = await DAO.Update(Member, data);
    return refetch_data;
  }

  static async Delete(data: Member): Promise<number> {
    let effect_rows_cnt = await DAO.DeleteByGuid(Member, data.guid);
    return effect_rows_cnt;
  }

  static async UpdateOneField(find_data: Member, field: string, value: any) {
    (find_data as any)[field] = value;

    let re = await DAO.UpdateOnly(Member, find_data, [field]);

    return re;
  }

  static async WS_Update_標記為完成特作(member: Member) {
    member.spwk_done_at = dayjs().format("YYYY/MM/DD HH:mm:ss");

    let api_rslt: ApiResult = await WS.CallWS(
      "uni_member/update_spwk_done_at",
      member
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassObject(Member, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }

  static async UpdateOneField_Common_Uni_Func_Guids(
    find_data: Member,
    field: string,
    value: any
  ) {
    (find_data as any)[field] = value;

    let re = await DAO.UpdateOnly(Member, find_data, [field]);

    return re;
  }

  static async Update_CommonUniFuncGuids(
    member: Member,
    common_uni_func_guids: string[]
  ) {
    member.setCommonUniFuncGuids(common_uni_func_guids); // member.common_uni_func_guids = _F01﹋_F03﹋_F05

    await DAO.UpdateOnly(Member, member, ["common_uni_func_guids"]);
  }

  /**
   * 更新 CommonUniFuncGuids() 只會新增，不會移除
   */
  static async Update_更新受檢者一般問卷的Guids(
    member: Member,
    set_common_uni_func_guids: string[]
  ) {
    let ori_common_guids: string[] = member.getCommonUniFuncGuids();

    let memebr_age = member.計算年齡();
    if ((memebr_age as number) < 45) {
      // 小於 45 歲，則移除 F04
      set_common_uni_func_guids = set_common_uni_func_guids.filter(
        (guid) => guid !== SpwkUtilV3.FUNC_GUID_F04
      );
    }

    let combine_common_guids: string[] = [
      ...ori_common_guids,
      ...set_common_uni_func_guids,
    ];

    const distinct_common_guids = new Set(combine_common_guids); //['_F01', '_F05', '_F01', '_F03'] => {'_F01', '_F05', '_F03'}
    let new_common_guids = Array.from(distinct_common_guids).sort(); // {'_F01', '_F05', '_F03'} => ['_F01', '_F03', '_F05']

    await MemberDAO.Update_CommonUniFuncGuids(member, new_common_guids);
  }

  static async WS_UpdateAllQuestDoneDt(member: Member) {
    member.all_quest_done_dt = dayjs().format("YYYY/MM/DD HH:mm:ss");

    let api_rslt: ApiResult = await WS.CallWS(
      "uni_member/update_all_quest_done_dt",
      member
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassObject(Member, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }

  /**
   * cid=問卷網頁編號，因為帳密可能重複，且如果要再登入頁就看到一些資訊，未來要用這個變數來查詢
   *
   */
  static async Login(
    cid: string,
    username: string,
    password: string
  ): Promise<ApiResult | null> {
    const result = await API.Call_POST(API_ROUTE_auth_member_login, {
      cid,
      username,
      password,
    });

    if (result.code === API.CODE_OK) {
      return result;
    } else if (result.message !== "") {
      return result;
    } else {
      return null;
    }
  }
  static async Update_RecDt(member: Member) {
    let re = await DAO.UpdateOnly(Member, member, ["rec_dt"]);
    return re;
  }
  static async Update_ID_PW(
    data: Member,
    id: string,
    pw: string
  ): Promise<Member> {
    data.member_id = id;
    data.member_pw = pw;
    let re = await DAO.UpdateOnly(Member, data, ["member_id", "member_pw"]);
    return re;
  }
  static async Update_His(member: Member) {
    let re = await DAO.UpdateOnly(Member, member, [
      "his_upload_dt",
      "his_upload_err_msg",
    ]);
    return re;
  }
  static async Update_Ui(member: Member) {
    let re = await DAO.UpdateOnly(Member, member, [
      "ui_upload_dt",
      "ui_upload_err_msg",
    ]);
    return re;
  }
  static async Update_Gov(member: Member) {
    let re = await DAO.UpdateOnly(Member, member, [
      "gov_upload_dt",
      "gov_upload_err_msg",
    ]);
    return re;
  }
  static async UpdateDrComment(
    find_data: Member,
    field: string,
    his_dto: HisDto
  ) {
    let value: HisDto = his_dto;
    let data = JSON.stringify(value.問卷UI基礎, null, 4);
    (find_data as any)[field] = data;
    let re = await DAO.UpdateOnly(Member, find_data, [field]);
    return re;
  }

  static async WS_GetDrComment(
    member_code: string | null
  ): Promise<any | undefined> {
    let api_rslt: ApiResult = await WS_Sys.CallPublicPost(
      "select_by_member_code",
      { member_code: member_code }
    );
    if (api_rslt.code === API.CODE_OK) {
      return api_rslt.data;
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }
}

class Cnd {
  static 指定場次(project_guid: string) {
    return ` (project_guid='${project_guid}') `;
  }
}

export function useMember(guid: string | undefined) {
  const ctx = useAppContext();

  const [_Member, set_Member] = useState<Member | null | undefined>(undefined);

  async function refresh_Member() {
    try {
      if (guid === undefined) {
        set_Member(undefined);
        return;
      }

      const data_list = await MemberDAO.WS_FetchByGuid(guid);
      set_Member(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  }

  useEffect(() => {
    refresh_Member();
  }, [guid]);

  return { _Member, set_Member, refresh_Member };
}

export function useMemberList(guid: string) {
  const ctx = useAppContext();

  const [_MemberList, set_MemberList] = useState<Member[]>([]);

  async function refresh_MemberList() {
    try {
      const data_list = await MemberDAO.Select(guid);

      set_MemberList(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  }

  useEffect(() => {
    refresh_MemberList();
  }, [guid]);

  return { _MemberList, set_MemberList, refresh_MemberList };
}
